/**
 * List of all english error messages by error code 
 */
const _messagesEN = {
    530: "An unexpected error occurred",
    531: "Invalid login or password",
    533: "Wrong authentification key",
    534: "Expired authentification key",
    535: "Too many attempts, please try again later"
};

type ErrorMessageRecord = typeof _messagesEN;

/**
 * List of all french error messages by error code 
 */
const _messagesFR: ErrorMessageRecord = {
    530: "Une erreur inattendue s'est produite",
    531: "Identifiant ou mot de passe incorrect",
    533: "Clé d'authentification érronée",
    534: "Clé d'authentification expirée",
    535: "Trop de tentatives, veuillez ré-essayer plus tard"
};

/**
 * Action related error messages per language and per code (messages["fr"][900])
 */
export const ERROR_MESSAGES = {
    "en": _messagesEN,
    "fr": _messagesFR
};